<div class="flex justify-end">
    <button *ngIf="!readOnly" [disabled]="!configureGrant" color="primary" class="block" mat-raised-button
        (click)="openGrantPopup()">
        Manage
    </button>
</div>

<table>
    <thead>
        <tr>
            <th>
                Field
            </th>
            <th>
                Current Value
            </th>

            <th>
                Desired Value
            </th>

            <th>
                Status
            </th>
        </tr>
    </thead>

    <tr>
        <td>
            Grant
        </td>

        <td>
            <ng-container *ngIf="policy?.grantControls?.builtInControls?.length > 0">

                <div *ngFor="let item of policy?.grantControls?.builtInControls">
                    {{ getBuildInControlName(item)}}
                </div>
            </ng-container>

            <div *ngIf="policy?.grantControls?.authenticationStrength?.id">
                <ul>
                    Require authentication strength

                    <li>
                        {{currentAuthenticationStrengthDisplayName}}
                    </li>

                </ul>
            </div>

            <ng-container
                *ngIf="!(policy?.grantControls?.authenticationStrength?.id || policy?.grantControls?.builtInControls?.length > 0)">
                --
            </ng-container>
        </td>

        <!-- desired value  -->
        <td>
            <mat-label class="block"
                *ngFor="let item of desiredBuiltInControlsValue">{{getBuildInControlName(item)}}</mat-label>

            <ul *ngIf="desiredAuthenticationStrengthDisplayName">
                Require authentication strength
                <li>

                    <mat-label class="block">

                        {{desiredAuthenticationStrengthDisplayName}}
                    </mat-label>
                </li>
            </ul>

            <ng-container *ngIf="!(desiredBuiltInControlsValue || desiredBuiltInControlsValue?.length > 0)">
                --
            </ng-container>
        </td>

        <td>
            <sway-baseline-status *ngIf="policy?.id" [hasError]="
                    errorsString?.includes('builtInControls')
                    || errorsString?.includes('authenticationStrength')
                    || (errorsString?.includes('grantControls') && !errorsString?.includes('operator'))
                    ">
            </sway-baseline-status>

            <mat-icon *ngIf="!policy?.id" class="warn-icon"
                matTooltip="Baseline is not associated with any policy">warning</mat-icon>
        </td>
    </tr>

    <tr>
        <td>
            Operator
        </td>

        <td>
            {{ multipleControls[policy?.grantControls?.operator] || '---'}}
        </td>


        <td>
            <mat-label class="block">{{ multipleControls[desiredOperatorControl.value] || '---'}}</mat-label>
        </td>

        <td>
            <sway-baseline-status *ngIf="policy?.id"
                [hasError]="desiredOperatorControl.value != policy?.grantControls?.operator">
            </sway-baseline-status>
            <mat-icon *ngIf="!policy?.id" class="warn-icon"
                matTooltip="Baseline is not associated with any policy">warning</mat-icon>

        </td>

    </tr>


    <ng-template #grantPopupRef>
        <h1 mat-dialog-title>Grant</h1>

        <mat-radio-group [(ngModel)]="grantControl" (change)="toggleMainController()">
            <div class="mb-3">
                <mat-radio-button value="block">Block access</mat-radio-button>
            </div>

            <div class="grant-access-block">
                <div class="mb-3">
                    <mat-radio-button value="grant">Grant Access</mat-radio-button>
                </div>

                <div class="checkbox-block mb-2">

                    <ng-container *ngFor="let buildControl of buildControllers">

                        <mat-checkbox [disabled]="buildControl.disabled"
                            (change)="onCheckboxChange(buildControl.value, buildControl.checked)"
                            [(ngModel)]="buildControl.checked">
                            {{buildControl.name}}

                        </mat-checkbox>

                        <ng-container *ngIf="buildControl.value === 'authenticationStrength'" && buildControl.checked>

                            <mat-form-field appearance="fill">

                                <mat-select [disabled]="!buildControl.checked"
                                    [(ngModel)]="authenticationStrengthValue">
                                    <mat-option
                                        [ngStyle]="{'height': 'auto', 'min-height': '2rem', 'white-space': 'normal'}"
                                        *ngFor="let policy of authenticationStrengthPolicies;" [value]="policy?.id">
                                        <div>

                                            {{policy?.displayName}}
                                        </div>

                                        <div class="gray">
                                            {{policy?.description}}
                                        </div>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </mat-radio-group>

        <p>
            For multiple controls
        </p>

        <mat-radio-group [formControl]="operatorControl" >
            <div class="mb-3">
                <mat-radio-button [disabled]="grantControl === 'block'" value="AND">Require all the selected controls</mat-radio-button>
            </div>

            <div class="mb-3">
                <!-- [disabled]="desiredBuiltInControlsValue?.includes('block')"   -->
                <mat-radio-button value="OR">Require one of the selected controls</mat-radio-button>
            </div>
        </mat-radio-group>

        <div class="actions">
            <button mat-dialog-close="true"   mat-raised-button color="primary">
                Save
            </button>

            <button mat-dialog-close mat-raised-button>
                Cancel
            </button>
        </div>
    </ng-template>
</table>
